import { render } from "./BaseInput.vue?vue&type=template&id=b1d73278&scoped=true"
import script from "./BaseInput.vue?vue&type=script&lang=js"
export * from "./BaseInput.vue?vue&type=script&lang=js"

import "./BaseInput.vue?vue&type=style&index=0&id=b1d73278&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b1d73278"

export default script